import React, { useState } from 'react';
import PrimaryButton from '../Button/Button';
import { generateMoldAssessmentPDF, downloadMoldAssessmentPDF } from './PDFGenerator';
import toast from 'react-hot-toast';

function Actions({ onEditModeChange, isEditMode, onSave, onCancel, isSaving = false, data, buildingData, apartmentNumber, moldType, inspectorCertificate, inspectorLicense, ticketData }) {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleEdit = () => {
    onEditModeChange(true);
  };

  const handleSave = () => {
    if (onSave && !isSaving) {
      onSave();
    }
    // Don't exit edit mode here - let the form submission handle it
  };

  const handleCancel = () => {
    if (onCancel && !isSaving) {
      onCancel();
    }
    if (!isSaving) {
      onEditModeChange(false);
    }
  };

  const handleDownload = async () => {
    if (!data) {
      toast.error('No data available to generate PDF');
      return;
    }

    setIsDownloading(true);
    try {
      const doc = await generateMoldAssessmentPDF(data, buildingData, apartmentNumber, moldType, inspectorCertificate, inspectorLicense, ticketData);
      
      // Generate filename
      const propertyAddress = data?.property_address || buildingData?.address || 'Mold_Report';
      const sanitizedAddress = propertyAddress.replace(/[^a-z0-9]/gi, '_').substring(0, 50);
      const fileName = `Mold_Assessment_${sanitizedAddress}_${data?.violation_id || 'Report'}.pdf`;
      
      downloadMoldAssessmentPDF(doc, fileName);
      toast.success('PDF downloaded successfully');
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Failed to generate PDF. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="d-flex justify-content-end mr-30">
      {!isEditMode ? (
        <>
          <PrimaryButton 
            variant="contained" 
            color="primary" 
            sx={{ marginRight: '8px' }}
            onClick={handleEdit}
          >
            Edit
          </PrimaryButton>
          <PrimaryButton 
            variant="contained" 
            color="primary"
            onClick={handleDownload}
            disabled={isDownloading}
          >
            {isDownloading ? 'Generating...' : 'Download'}
          </PrimaryButton>
        </>
      ) : (
        <>
          <PrimaryButton 
            variant="contained" 
            color="primary" 
            sx={{ marginRight: '8px' }}
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </PrimaryButton>
          <PrimaryButton 
            variant="outlined" 
            color="primary"
            onClick={handleCancel}
            disabled={isSaving}
          >
            Cancel
          </PrimaryButton>
        </>
      )}
    </div>
  )
}

export default Actions